import { render, staticRenderFns } from "./ModalVoidPayslips.vue?vue&type=template&id=f859d6bc"
import script from "./ModalVoidPayslips.vue?vue&type=script&lang=js"
export * from "./ModalVoidPayslips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f859d6bc')) {
      api.createRecord('f859d6bc', component.options)
    } else {
      api.reload('f859d6bc', component.options)
    }
    module.hot.accept("./ModalVoidPayslips.vue?vue&type=template&id=f859d6bc", function () {
      api.rerender('f859d6bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payslips/ModalVoidPayslips.vue"
export default component.exports